import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class EdsCategoryOpenAllEvent extends EventV2<object> {}
